import { useTranslation } from 'react-i18next';

import {
  FiltersDrawer,
  PrimaryFiltersRow,
  SavedFiltersBadgeRow,
  UniversalFiltersProvider,
} from '~/modules/universalFilters';

import { Button, Icon } from '@vestigas/ui';
import {
  DataManagementLayout,
  PageTitle,
} from '~/ui/layouts/DataManagementLayout';

import { LedgerAccountFormDialog } from './components/LedgerAccountFormDialog';
import { LedgerAccountsDataTable } from './components/LedgerAccountsDataTable';
import { LedgerAccountImportDialog } from './import/LedgerAccountImportDialog';
import { useLedgerAccountsPage } from './useLedgerAccountsPage';

export function LedgerAccountsPage() {
  const { t } = useTranslation('ledgerAccounts');

  const {
    closeDialog,
    closeImportDialog,
    filterConfig,
    isDialogOpen,
    isImportDialogOpen,
    ledgerAccountId,
    openCreateDialog,
    openImportDialog,
    savedFilterUrlSync,
    savedFiltersState,
  } = useLedgerAccountsPage();

  return (
    <UniversalFiltersProvider
      config={filterConfig}
      savedFilterUrlSync={savedFilterUrlSync}
      savedFiltersState={savedFiltersState}
    >
      <DataManagementLayout>
        <PageTitle className="pt-4">{t(($) => $.list.pageTitle)}</PageTitle>

        <SavedFiltersBadgeRow />
        <PrimaryFiltersRow>
          <Button
            icon={<Icon metaphor="uploadFile" />}
            text={t(($) => $.import.openButton.text)}
            onClick={openImportDialog}
          />
          <Button
            icon={<Icon metaphor="add" />}
            text={t(($) => $.list.addButton.text)}
            onClick={openCreateDialog}
          />
        </PrimaryFiltersRow>

        <div className="min-h-0 w-full flex-1">
          <LedgerAccountsDataTable />
        </div>
      </DataManagementLayout>

      <FiltersDrawer />

      <LedgerAccountFormDialog
        isOpen={isDialogOpen}
        ledgerAccountId={ledgerAccountId}
        onClose={closeDialog}
      />

      <LedgerAccountImportDialog
        isOpen={isImportDialogOpen}
        onClose={closeImportDialog}
      />
    </UniversalFiltersProvider>
  );
}
